import { Bugsnag } from "lib/bugsnag";
import { useEffect } from "react";
import { apiActions } from "screens/login/hooks/use-login-wizard";

export function useEffectLogout(isLogout: boolean) {
  useEffect(() => {
    if (isLogout) {
      // The logout invalidates the session and rotates the CSRF token,
      // so refresh the CSRF cookie once it settles to ensure the cookie
      // jar is consistent before the user submits the login form.
      // Neither failure is actionable for the user here: a failed CSRF
      // refresh re-surfaces through the 419 retry on submit
      apiActions
        .logout()
        .catch((e) => Bugsnag.notify(e))
        .then(() => apiActions.fetchCsrf())
        .catch(() => undefined);
    }
  }, [isLogout]);
}
